export enum FightResult {
  WIN = 'W',
  LOSS = 'L',
  DRAW = 'D',
  NO_CONTEST = 'NC',
  NONE = 'N',
}
